import { colors } from 'theme'

export const defaultThemeMapLocationStyles = {
    background: colors.white,
    hoverBackground: colors.blue,
    text: colors.black,
    hoverText: colors.white,
    shadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
}
